import { BaseRequest, BaseResponse } from '../models'
import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { paginate } from '../utils'
import { WebNotification } from '../../models/Notification'

const _BASE_URL = import.meta.env.REACT_APP_NOTIFICATIONS_BASE_URL!

export interface GetWebNotificationsRequest extends BaseRequest {}

export interface ChangeWebNotificationStateRequest extends BaseRequest {
  webNotificationId: string
  newState: 'read' | 'unread' | 'dismissed'
}

export const webNotificationsApi = createApi({
  reducerPath: 'webNotificationsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getWebNotifications: builder.query<BaseResponse<WebNotification[]>, GetWebNotificationsRequest>({
      async queryFn(request, _queryApi, _extraOptions, fetchWithBQ) {
        return await paginate<WebNotification>(
          {
            url: `/accounts/${request.accountId}/web-notifications`,
            params: { state: 'read,unread' },
          },
          fetchWithBQ,
        )
      },
    }),
    changeWebNotificationState: builder.mutation<void, ChangeWebNotificationStateRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/web-notifications/${request.webNotificationId}/change-state`,
        method: 'POST',
        body: { newState: request.newState },
      }),
    }),
  }),
})

export const { useGetWebNotificationsQuery, useChangeWebNotificationStateMutation } = webNotificationsApi
